import { render, staticRenderFns } from "./ConfigSource.vue?vue&type=template&id=50f169c0&scoped=true&"
import script from "./ConfigSource.vue?vue&type=script&lang=js&"
export * from "./ConfigSource.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSource.vue?vue&type=style&index=0&id=50f169c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f169c0",
  null
  
)

export default component.exports